import * as action_types from './action_types';

export const hideSplash = () => {
    return {
        type: action_types.HIDE_SPLASH,
        data: {
            hideSplash: true
        }
    }
};

export const showSplash = () => {
    return {
        type: action_types.SHOW_SPLASH,
        data: {
            hideSplash: false
        }
    }
};


// WEBPACK FOOTER //
// ./src/actions/SplashScreenActions.js